export const RecebaCotModel = {
  nome: "",
  email: "",
  telefone: "",
  periodo: "",
  formaContato: 0,
  tipoCotacao: "",
};
